import { Box } from '@mui/material'
import type { UserStatusEnum } from '@/@data'

interface StatusIndicatorProps {
  status: UserStatusEnum
  size?: number
}

const StatusIndicator = ({ status, size = 8 }: StatusIndicatorProps) => {
  const getStatusColor = (status: UserStatusEnum) => {
    switch (status) {
      case 'active':
        return '#4caf50' // Green
      case 'inactive':
        return '#ff9800' // Orange
      case 'blocked':
        return '#f44336' // Red
      case 'waiting':
        return '#ff9800' // Orange
      case 'guest':
        return '#9c27b0' // Purple
      case 'guest_waiting':
        return '#607d8b' // Blue Grey
      default:
        return '#9e9e9e' // Grey
    }
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: getStatusColor(status),
        display: 'inline-block',
        marginLeft: 1,
        flexShrink: 0
      }}
    />
  )
}

export default StatusIndicator
